module.exports = __webpack_public_path__ + "static/Starwars-4ceee78846b7bc088a60596537945ee3.png";